import { render, staticRenderFns } from "./RTPNetworkList.vue?vue&type=template&id=64f5133b&"
import script from "./RTPNetworkList.vue?vue&type=script&lang=js&"
export * from "./RTPNetworkList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports